import React , {useState} from "react"
import styled from 'styled-components'
import ListViewItem from "./ListViewItem"
import Text from "../../../global/typo/Text"
import { useTranslation } from 'react-i18next'

const getCoverLink = ({story}) => {
  const baseUrl = 'https://storage.googleapis.com/audiodesires-aab7f.appspot.com'
  if(story.type === "audiobook") return `${baseUrl}/audiobooks/${story.id}/artwork/200/200.webp`
  const fileName = story.imageUrl.split('/').pop().split('.')[0]
  if(story.type === "story") return `${baseUrl}/stories/${story.id}/artwork/200/${fileName}.webp`
  if(story.type === "sleep") return `${baseUrl}/sleep/${story.id}/artwork/200/${fileName}.webp`
  if(story.type === "community") return `${baseUrl}/communityStories/${story.id}/artwork/200/${fileName}.webp`
}



const MoreLikeThis = (props) => {
  const { similarStories, seriesStories, sameScenarioStories, audiodesiresOriginal} = props;
  const [activeTab, setActiveTab] = useState(seriesStories?.length > 0 ?'series' :'similar');
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  return(
    <RecommendationWrapper>
      <TabsWrapper>
        {seriesStories?.length > 0 && <Tabs $activeTab={ activeTab === 'series'} onClick={() => setActiveTab('series')}><TabsText>{t('more-like-this.seriesStories')}</TabsText></Tabs> }
        <Tabs $activeTab={ activeTab === 'similar'} onClick={() => setActiveTab('similar')}><TabsText>{t('more-like-this.moreLikeThis')}</TabsText></Tabs>
        {sameScenarioStories.length > 0 && <Tabs $activeTab={ activeTab === 'scenario'} onClick={() => setActiveTab('scenario')}><TabsText>{t('more-like-this.sameScenario')}</TabsText></Tabs> }
      </TabsWrapper>
      <SimilarStoriesWrapper>
        {activeTab === 'similar' && 
          <>
            {similarStories && similarStories.map(story =>(
              <ListViewItem
                id={story.id}
                slug={story.type === "community" ? story.slug : story[lang].slug}
                title={story.type === "community" ? story.title : story[lang].title}
                thumbnail={getCoverLink({story})}
                duration={story.type === "community" ? story.duration : story[lang].duration}
                voices={story.type === "community"  ? story.voices : story[lang].voices}
                mainTag={story.type === 'sleep' ? story.mainTag[lang].tag : story.mainFantasy[lang].fantasy}
                spiciness={story.type === 'sleep' ? '0' : story.spiciness}
                key={story.id}
                audioUrl={story.audioUrl}
                type={story.type}
              />
            ))}
          </>
        }
        {activeTab === 'scenario' && 
          <>
            {sameScenarioStories && sameScenarioStories.map(story =>(
              <ListViewItem
                id={story.id}
                slug={story.type === "community" ? story.slug : story[lang].slug}
                title={story.type === "community" ? story.title : story[lang].title}
                thumbnail={getCoverLink({story})}
                duration={story.type === "community" ? story.duration : story[lang].duration}
                voices={story.type === "community"  ? story.voices : story[lang].voices}
                mainTag={story.type === 'sleep' ? story.mainTag[lang].tag : story.mainFantasy[lang].fantasy}
                spiciness={story.spiciness}
                key={story.id}
                audioUrl={story.audioUrl}
                type={story.type}
              />
            ))}
          </>
        }
        {activeTab === 'series' && 
          <>
            {seriesStories && seriesStories.map(story =>(
              <ListViewItem
                id={story.id}
                slug={story.type === "community" ? story.slug : story[lang].slug}
                title={story.type === "community" ? story.title : story[lang].title}
                thumbnail={getCoverLink({story})}
                duration={story.type === "community" ? story.duration : story[lang].duration}
                voices={story.audiodesiresOriginal ? story[lang].voices : story.voices}
                mainTag={story.type === 'sleep' ? story.mainTag[lang].tag : story.mainFantasy[lang].fantasy}
                spiciness={story.spiciness}
                premiumContent={audiodesiresOriginal ? story[lang].premiumContent : story.premiumContent}
                audiodesiresOriginal={story.audiodesiresOriginal}
                key={story.id}
                audioUrl={story.audioUrl}
                type={story.type}
              />
            ))}
          </>
        }
      </SimilarStoriesWrapper>
    </RecommendationWrapper>
  )
}

export default MoreLikeThis;


const RecommendationWrapper = styled.div`
  margin-top:30px;
  p{
    margin:0px;
  }
`

const SimilarStoriesWrapper = styled.div`
  padding-top:20px;
  margin-top:0;
`

const TabsWrapper = styled.div`
  display:flex;
  border-bottom: solid 4px #f19d9a75;
`

const Tabs = styled.div`
  ${props => props.$activeTab ? 'border-bottom:solid 4px #F19D9A': ''};  
  padding-bottom:5px;
  margin-bottom:-4px;
  padding-right:10px;
  &:not(:first-child){
    padding-left:10px;
  }
`

const TabsText = styled(Text)`
  text-transform: uppercase;
  line-height:1.1;
`
    